import type React from 'react';
import { Modal } from '@zillow/constellation-10';

type LeaseModalProps = {
  id?: string;
  isOpen?: boolean;
  onClose?: () => void;
  header?: React.ReactNode;
  body?: React.ReactNode;
  footer?: React.ReactNode;
  'data-test'?: string;
  shouldCloseOnOutsideClick?: boolean;
  shouldCloseOnESCKeyPress?: boolean;
};

export default function LeaseModal({
  isOpen,
  onClose,
  header,
  body,
  footer,
  shouldCloseOnOutsideClick = false,
  shouldCloseOnESCKeyPress = true,
  ...props
}: LeaseModalProps): JSX.Element {
  // Convert old props to new useDismissProps format
  const useDismissProps = {
    escapeKey: shouldCloseOnESCKeyPress,
    outsidePress: shouldCloseOnOutsideClick,
  };

  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose?.();
        }
      }}
      size={{ base: 'fullScreen', md: 'sm' }}
      useDismissProps={useDismissProps}
      header={header}
      body={body}
      footer={footer}
      {...props}
    />
  );
}
